import styled from "styled-components";

export const StyledAdmissionAcceptRejectNote = styled.div`
      background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(176, 186, 197, 0.600289);
  padding: 16px;
  
  .br-red{
    border-color: #DC3545 !important;
  }
  
  .br-blue{
    border-color: #009CF8 !important;
  }
  
  .br-purple{
    border-color: #AE7DD1 !important;
  }
  
  .br-orange{
    border-color: #E38619 !important;
  }
  
  .br-green{
    border-color: #2C8742 !important;
  }
  
  .col-red{
    color: #DC3545 !important;
    
      &:hover, &:focus, &:active{
        background: #DC3545 !important;
        color: #fff !important;
      }
  }
  
  .col-blue{
    color: #009CF8 !important;
  }
  
  .col-purple{
    color: #AE7DD1 !important;
  }
  
  .col-orange{
    color: #E38619 !important;
  }
  
  .col-gray{
    color: #98A0A6 !important;
  }
  
  
  .col-green{
    color: #2C8742 !important;
    
      &:hover, &:focus, &:active{
        background: #2C8742 !important;
        color: #fff !important;
      }
  }
  
  .ant-checkbox-wrapper{
    display: flex;
    align-items: center;
    
    .ant-checkbox{
      top: 0;
    }
    
    .ant-checkbox-checked::after{
      border: 1px solid #51258F;
    }
    
    .ant-checkbox-checked .ant-checkbox-inner{
        background-color: #51258F;
        border-color: #51258F;
    }
    
    .ant-checkbox-inner{
      width: 24px;
      height: 24px;
      
      &:after{
        width: 9px;
        height: 12px;
        left: 30%;
      }
    }
  }
  
  .ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon{
     border-color: #51258F;
  }
  
  .ant-steps .ant-steps-item:not(.ant-steps-item-active):not(.ant-steps-item-process) > .ant-steps-item-container[role='button']:hover .ant-steps-item-icon .ant-steps-icon{
    color: #51258F;
  }
  
  .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-title, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-subtitle, .ant-steps .ant-steps-item:not(.ant-steps-item-active) > .ant-steps-item-container[role='button']:hover .ant-steps-item-description{
    color: #51258F;
  }
  
  h1{
    font-weight: 500;
    font-size: 42px;
    line-height: 38px;
  }
  
  .admission{
      padding: 24px 32px;
    
      background-color: #fff;
      
      border: none;
      border-radius: 0;
      border-bottom: 1px solid rgba(196, 200, 203, 0.3);
    
        &__button-content{
          display: flex;
        }
      
        &__title{
          font-weight: 700;
        }
        
        &__subtitle{
          margin-bottom: 16px;
        }
        
        &__button{
          height: 40px;
          
          display: flex;
          align-items: center;
          
          &:not(:first-child){
             margin-left: 16px;
          }
                    
          &--item{
             padding: 8px 16px;
          }
                    
          .ant-image{
            margin-left: 8px;
          }
        }
        
        &__content-item{
          padding-bottom: 16px;
          margin-bottom: 16px;
          border-bottom: 1px solid rgba(196, 200, 203, 0.3);
          
          .ant-collapse{
            background-color: transparent;
            border: 1px solid rgba(196,200,203,0.5);
            border-radius: 8px;
            
            &-item{
              border-bottom: none;
            }
            
            &-content{
              background-color: transparent;
            }
          }
          
          .ant-select-selector{
            border-radius: 8px;
            min-width: 50px;
          }
        }
        
        &__table{
                
          .ant-table-thead{
          
            .ant-table-cell{
              background-color: rgba(81, 37, 143, 0.2) !important;
            }
          }
          
          .ant-table-tbody{
          
            .ant-table-cell{
              padding: 8px 17px !important;
              text-align: left;
            }
            
            .blue{
              background: #E5F5FE;
            }
          }
        }
        
        &__download{
          display: flex;
          align-items: center;
          font-size: 16px;
          
          &:hover{
            border-color: transparent;
          }
          
          .ant-image{
            display: flex;
            margin-right: 16px;
          }
        }
        
        &__middle-mark{
          width: 100%;
          
          span{
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            margin-left: 8px;
          }
          
          &--orange{
            background: rgba(254, 239, 213, 0.5);
            border-color: rgba(254, 239, 213, 0.5);
          }
          
          &--blue{
            background: rgba(0, 156, 248, 0.15);
            border-color: rgba(0, 156, 248, 0.15);
          }
        }
        
        &__footer{
          padding: 8px 0 16px 0;
        }
        
        &__error{
          margin-bottom: 24px;
          padding: 0;
          border-radius: 4px;
          
          .ant-image{
            padding: 14px;
            background: #DC3545;
          }
          
          .ant-alert-message{
            padding: 4px 24px;
          }
        }
        
        
        &__select{
          width: 100%;
        }
        
       
        
        .ant-steps{
          left: 0;
          padding: 0;
        }
      
  }
  
   .marks{
    border-radius: 8px;
    border: 1px solid #51258F;
    overflow: hidden;
    
    &--gray{
      border-color: #F2F2F2;
    }
    
    &--green{
      border-color: #51258F;
    }    
    
    &--orange{
      border-color: rgba(254, 239, 213, 0.5);
    }
    
    &:not(:last-child){
      margin-bottom: 10px;
    }
    
    &__content{
      padding: 8px;
      
      & > .ant-col:not(:last-child){
        margin-bottom: 8px;
      }
    }
    
    &__header{
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: #2E384D;
      
      &--gray{
        background: #F2F2F2;
      }
      
      &--green{
        background: rgba(81, 37, 143, 0.2);
      }    
      
      &--orange{
        background: rgba(254, 239, 213, 0.5);
      }
    }
    
    &__item{
      display: flex;
      align-items: center;
            
      &:not(:last-child){
        margin-bottom: 8px;
      }
      
      span{
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }
      
      .ant-typography{
        margin-left: 8px;
      }
    }
    
    &__input{
      width: 100%;
      height: 100%;
      border-radius: 8px;
      text-align: center;
      
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #2E384D;
      
      .ant-select-selection-item{
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    
    &__footer{
      padding: 16px 0;
    }
  }  
    
`